import { render } from "./PhoneNumberDisplay.vue?vue&type=template&id=09385cf4"
import script from "./PhoneNumberDisplay.vue?vue&type=script&lang=js"
export * from "./PhoneNumberDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__